// extracted by mini-css-extract-plugin
export var resizer = "_ee-0";